export const messages = {
  playSolo: "Jouer seul",
  gameInstructions:
    "Dans ce mini jeu, ton objectif est de nommer une carte aléatoire Gwent depuis son illustration. Les cartes utilisées dans ce jeu viennent du <meta>dernier rapport de méta</meta> de <leviathan>Team Leviathan</leviathan>. C'est un bon moyen pour s'améliorer tout en s'amusant !",
  difficultyLevel:
    "{difficultyLevel, select, easy {<b>Facile</b>: illustration complète, choix parmi 3 propositions.} medium {<b>Moyen</b>: illustration complète, choix libre.} hard {<b>Difficile</b>: partie de l'illustration, choix parmi 3 propositions.} extreme {<b>Extrême</b>: partie de l'illustration, choix libre.}}",
  play: "Jouer",
  playWithTwitchChat: "Jouer avec ton chat Twitch",
  inspiredBy: "Inspiré par <a>Faberstein</a>",
  aboutCode: "À propos/Code",
  disclaimer:
    "Ceci est une œuvre de fan non officielle suivant le <a>Guide pour le contenu des fans de Gwent</a>. Non approuvée/soutenue par CD PROJEKT RED.",
  hint: "Indice ({remainCount} restants)",
  hintCardType:
    "C'est une carte {cardType, select, unit {unité} special {spéciale} artifact {artefact}}",
  hintFaction: "appartenant à {faction}",
  hintInitials: 'dont le nom débute par "{initials}"',
  gameOver: "Game Over!",
  gameOverSummary:
    "Tu as eu {correctAnswers} réponses corrects sur les {totalQuestions}. Fier ? Fais le savoir !",
  tweetText:
    "Je viens juste de nommer {correctAnswers} cartes Gwent parmi les {totalQuestions} aléatoires. Fais mieux !",
  tweet: "Tweet",
  playAgain: "Jouer",
  questionLabel: "Comment s'appelle cette carte ?",
  placeholder: "Nomme cette carte...",
  submit: "Envoyer",
  won: "Bravo !",
  wonUsername: "Bravo {username} !",
  cardNamed: "Cette carte s'appelle {localizedName}.",
  lost: "Nope.",
  butCardNamed:
    "Cette carte ne s'appelle pas {wrongLocalizedName} mais {correctLocalizedName}.",
  breakTimeLeft:
    "{seconds} secondes restantes avant la question suivante (<a>passer</a>).",
  changeLocaleWhilePlaying:
    "Afin de changer la langue actuelle, le jeu doit être redémarré. Souhaites-tu changer la langue et redémarrer le jeu ?",
  gameInstructionsTwitchChat:
    "Le jeu est le même. La seule différence est que votre navigateur va se connecter à votre chat Twitch et écoutera les messages de vos viewers. Il essaiera de faire correspondre leurs messages avec une carte et affichera le gagnant à l'écran si il en trouve un. Vos viewers n'ont pas besoin de donner le nom exact de la carte, le jeu utilise un mécanisme qui autorise les fautes d'orthographe.",
  channelRequired: "Ta chaîne Twitch est requise pour se connecter à ton chat.",
  twitchError:
    "La connexion à ton chat Twitch a échoué. Es-tu sûr d'avoir saisi ta chaîne correctement ?",
  connecting: "Connexion...",
  morvranTaunt1: "Ça va vous plaire.",
  morvranTaunt2: "Je ne voudrais pas vous presser, mais…",
  morvranTaunt3: "Navré, mais je dois vous détruire.",
  emhyrTaunt1: "Cet acharnement finit par être amusant.",
  emhyrTaunt2: "Attention à ne pas abuser de ma patience.",
  dettlaffTaunt1: "Tout votre monde va bientôt sombrer dans le sommeil.",
  dettlaffTaunt2: "Allez ! Remuez-vous !",
  dettlaffTaunt3: "Vous croyez que ça m'arrêtera ?",
  woodlandTaunt1: "...",
  eredinTaunt1: "Je te prendrais bien comme esclave.",
  eredinTaunt2: "Tu sais très bien comment ça va finir.",
  eredinTaunt3: "Tu vas périr, vermisseau.",
  meveTaunt1: "Attention, je vais être sans pitié.",
  meveTaunt2: "Attention, je perds patience.",
  meveTaunt3: "Vraiment ? Vous pensez avoir une chance ?",
  foltestTaunt1: "Vous êtes du genre coriace, vous.",
  foltestTaunt2: "Il suffit ! Cessez de tergiverser !",
  foltestTaunt3:
    "Grr, j'ai déjà vu des batailles tourner à l'aigre, mais celle-ci est un comble !",
  brouverTaunt1: "T'attends quoi pour t'décider, que je coasse ?",
  brouverTaunt2: "Ha ha ha ha ! Eh… sérieux, c'est ça qu'tu joues ?",
  brouverTaunt3: "Retenez-moi ou j'fais un malheur !",
};
